<script>
    export let text;
    export let centered = true;

    let className = '';

    if (!centered) {
        className = 'left';
    }
</script>

<h1 class={className}>{text}</h1>

<style>
    h1 {
        font-weight: 700;
        font-size: 36px;
        padding-bottom: 15px;
    }

    .left {
        text-align: left;
    }
</style>
